import React, { Component } from 'react';

import Shimmer from '../../../../components/shimmer';

import styles from './styles.css';

class OpportunityBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className={styles.spacing}>
        <div className={styles.box}>
          <div className={styles.paddingH}>
            <div className={`${styles.bottomLine} ${styles.paddingV}`}>
              <div className={styles.accountSection}>
                <div className={styles.accountPhoto}>
                  <Shimmer value={30} full className={styles.circleShimmer} />
                </div>
                <div className={styles.accountInfo}>
                  <div className={styles.accountName}>
                    <Shimmer value="XXXXXXXXXXXXXXXXXXXX" />
                  </div>
                  <div className={styles.accountDate} style={{ paddingTop: 5 }}>
                    <Shimmer value="XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <div className={styles.mainTitle}>
              <Shimmer value="XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX" />
            </div>
          </div>

          <div className={styles.section}>
            <Shimmer value="XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX" />
            &nbsp;&nbsp;&nbsp;
            <Shimmer value="XXXXXXXXXXXXXXXXXXXX" />
          </div>

          <div className={styles.topLine}>
            <div className={styles.section}>
              <Shimmer value="XXXXXXXXXXXXX" />
              &nbsp;&nbsp;&nbsp;
              <Shimmer value="XXXXXXXXXXXXX" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OpportunityBox.propTypes = {
};

OpportunityBox.defaultProps = {
};

export default OpportunityBox;
